import React from 'react';
import {
    Route,
    Switch,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { ErrorBoundary } from 'react-error-boundary';

import COLORS from '@mlb/react-patterns/style/universal.color';
import Theme from '@mlb/react-patterns/components/Theme/theme';

import Homepage from 'bdvp-homepage';
import LandingPage from 'bdvp-landing-page';
import PlaybackPage from 'bdvp-playback-page';
import ReelsPage from 'bdvp-reel/src/containers/ReelsPage';
import SearchPage, { FilterPanel } from 'bdvp-advanced-search';

import NotFound from 'bdvp-common/src/components/NotFound';
import ShareModal from 'bdvp-common/src/containers/ShareModal';
import ReelCreationModal from 'bdvp-reel/src/containers/CreationModal';
import { useAppView } from 'bdvp-common/src/hooks/config';
import { APP_VIEW } from 'bdvp-common/src/utils/constants';
import theme from 'bdvp-common/src/styles/theme';

import Subnav from '../../containers/Subnav';
import Bootstrap from '../../containers/Bootstrap';
import Template from '../Template';
import ErrorMsg from '../ErrorMsg';

const styles = css`
    body {
        width: 100%;
        height: unset;
        min-height: 100%;
        background-color: ${COLORS.mlbBlack};

        &[class*=league-], &[class*=team-] {
            background-color: ${COLORS.mlbBlack};
        }

        &.using-mouse {
            *:focus {
                outline: none;
            }
        }

        @supports (margin-top: constant(safe-area-inset-top)) {
            padding-top: constant(safe-area-inset-top, 0);
            padding-bottom: constant(safe-area-inset-bottom, 0);
        }

        @supports (margin-top: env(safe-area-inset-top)) {
            padding-top: env(safe-area-inset-top, 0);
            padding-bottom: env(safe-area-inset-bottom, 0);
        }

        main {
            overflow-x: unset !important;
            display: flex;
            align-items: stretch;
            flex-flow: column;
        }
    }

    #mlb-video-app {
        overflow: initial;
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;
        // Overriding some global styles from basesite
        [class*="lazyload"] {
            opacity: inherit;
            transition: none;
        }
    }
`;

const App = ({ isFilterActive }) => {

    const appView = useAppView();

    return (
        <Theme theme={theme} customStyles={styles}>
            <ErrorBoundary FallbackComponent={ErrorMsg} >
                <Bootstrap />
                <Template
                    subnav={appView !== APP_VIEW.ballpark && <Subnav />}
                    filter={<FilterPanel />}
                    isFilterActive={isFilterActive}
                    content={
                        <ErrorBoundary FallbackComponent={ErrorMsg} >
                            <Switch>
                                <Route exact path={'/'} component={Homepage} />
                                <Route path={'/search'} component={SearchPage} />
                                <Route path={'/topic/:topicId'} component={LandingPage} />
                                <Route path={'/:userId/reels/:contentId'} component={PlaybackPage} />
                                <Route path={'/:userId/reels'} component={ReelsPage} />
                                <Route path={'/:contentId'} component={PlaybackPage} />
                                <Route component={NotFound} />
                            </Switch>
                        </ErrorBoundary>
                    }
                    modals={
                        <>
                            <ShareModal />
                            <ReelCreationModal />
                        </>
                    }
                />
            </ErrorBoundary>
        </Theme>
    );

};

App.propTypes = {
    isFilterActive: PropTypes.bool,
};

App.defaultProps = {
    isFilterActive: false,
};

export default App;
